import type { Components } from 'react-markdown'

import { cn } from '@/utils'

export const PROSE_CLASSES = cn(
  'min-w-0 break-words [overflow-wrap:anywhere]',
  '[&_p]:text-[14px] [&_p]:leading-[22px] [&_p]:my-2 [&_p:first-child]:mt-0 [&_p:last-child]:mb-0',
  '[&_ul]:my-2 [&_ul]:ml-5 [&_ul]:list-disc [&_ul]:space-y-1',
  '[&_ol]:my-2 [&_ol]:ml-5 [&_ol]:list-decimal [&_ol]:space-y-1',
  '[&_li]:text-[14px] [&_li]:leading-[22px]',
  '[&_li>strong]:!inline [&_li>strong]:!mt-0',
  '[&_a]:text-foreground [&_a]:underline [&_a]:underline-offset-2 [&_a:hover]:opacity-80',
  '[&_code]:font-mono [&_code]:text-[12.5px] [&_code]:bg-foreground/[0.07] [&_code]:rounded [&_code]:px-1 [&_code]:py-0.5 [&_code]:[overflow-wrap:anywhere]',
  '[&_pre]:my-2 [&_pre]:p-3 [&_pre]:rounded-lg [&_pre]:bg-foreground/[0.06] [&_pre]:border [&_pre]:max-w-full [&_pre]:min-w-0 [&_pre]:whitespace-pre-wrap [&_pre]:break-words [&_pre]:[overflow-wrap:anywhere]',
  '[&_pre_code]:bg-transparent [&_pre_code]:p-0 [&_pre_code]:text-[12.5px] [&_pre_code]:whitespace-pre-wrap [&_pre_code]:break-words',
  '[&_blockquote]:my-2 [&_blockquote]:border-l-2 [&_blockquote]:border-muted-foreground/30 [&_blockquote]:pl-3 [&_blockquote]:text-muted-foreground',
  '[&_strong]:font-semibold',
  '[&_:is(h1,h2,h3,h4,h5,h6)]:text-[14px] [&_:is(h1,h2,h3,h4,h5,h6)]:font-semibold [&_:is(h1,h2,h3,h4,h5,h6)]:text-foreground [&_:is(h1,h2,h3,h4,h5,h6)]:mt-4 [&_:is(h1,h2,h3,h4,h5,h6)]:mb-1 [&_:is(h1,h2,h3,h4,h5,h6):first-child]:mt-0',
  '[&_hr]:my-3 [&_hr]:border-border',
)

// Markdown tables are forbidden by the system prompt: the agent must use
// `render_table` instead. Drop any stray markdown table on the floor so the
// agent's misbehavior is visible (empty space where a table would be)
// rather than papered over with a fake-looking artifact card.
export const PLAIN_PROSE_COMPONENTS: Partial<Components> = {
  pre: ({ children }) => (
    <p className="leading-7 not-first:mt-4 text-blue-7">{children}</p>
  ),
  code: ({ children }) => <>{children}</>,
  table: () => null,
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  hr: 'hr',
}
